
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/station-de-ski",
      function () {
        return require("private-next-pages/[region]/[resort]/station-de-ski.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/station-de-ski"])
      });
    }
  